(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galeria-producto-editable"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('editable-product-gallery')) {
customElements.define('editable-product-gallery', class extends HTMLElement {
connectedCallback() {
if (this.galleryReady) return;
this.galleryReady = true;
this.addEventListener('click', (event) => {
const button = event.target.closest('button[data-index]');
if (!button || !this.contains(button)) return;
const index = button.dataset.index;
this.querySelectorAll('[data-slide]').forEach((slide) => { slide.hidden = slide.dataset.slide !== index; });
this.querySelectorAll('button[data-index]').forEach((thumbnail) => { thumbnail.setAttribute('aria-pressed', String(thumbnail === button)); });
this.querySelector('.epg__status').textContent = 'Imagen ' + (Number(index) + 1) + ' de ' + this.querySelectorAll('[data-slide]').length;
});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
